  import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Cookies from 'universal-cookie'
import Auth from './auth'

const cookies = new Cookies()

export class ProtectedRoute extends React.Component { 
  constructor(props) {
    super(props)
    this.state = {
      Authenticated: true
    }
  }

  async componentDidMount() {
    console.log('com here?');
    try {
      if(Auth.isAuthenticated()) {
        let authenticaty = false
        const response = await fetch(process.env.REACT_APP_API_URL + '/check/teacher', {
          method: 'GET',
          headers: {
            'authorization': `Bearer ${cookies.get('admin_token')}`,
            'Content-Type': 'application/json',
          }
        })
        const result = await response.json()
        authenticaty = (result.success) ? true : false
        if(!authenticaty) {
          if(process.env.NODE_ENV === 'development') {
            cookies.remove('admin_token',{ path: '/' })
          }else {
            cookies.remove('admin_token',{ path: '/' })
          }
        }
        this.setState({ Authenticated: authenticaty })
      } else {
        this.setState({ Authenticated: false })
      }
    } catch(err) {
      this.setState({ Authenticated: false })
    }
  }

  render() {
    const { Authenticated } = this.state
    const { component: Component, ability, as, ...rest } = this.props
    return (
      <Route 
        {...rest}
        render={props => {
          if(Authenticated){
            return <Component {...props}/>
          } else {
            return (
              <Redirect
                to={{
                  pathname: '/',
                  state: {
                    from: props.location
                  }
                }}
              />
            )
          }
        }}
      />
    )
  }
}